import angular from 'angular';
import languageComponent from './language.component';

let languageModule = angular.module('language', [])

    .component('language', languageComponent)

    .name;

export default languageModule;



// WEBPACK FOOTER //
// ./src/app/common/language/language.js